// time measurement
import '@babel/polyfill'
window.timingMeasurement.jsInit = Date.now()
import 'es6-promise/auto'
import { store, router } from './app'
import app from './app'
import root from 'window-or-global'
import Tracking from 'pkg-bea-tracking'
import { polyfill } from 'smoothscroll-polyfill'
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.js'
import { sync } from 'vuex-router-sync'
import { preset } from 'pkg-cruise-api-endpoint'
import query from 'query-string'

root.isClient = true
root.locationTld = root.location
  ? root.location.hostname
      .split('.')
      .reverse()[0]
      .toUpperCase()
  : 'DE'

const location = root.location || {}

if (location.search) {
  const params = query.parse(location.search)
  preset.setPreviewToken(params.preview || preset.getPreviewToken())
  preset.setDraftId(params.draft || preset.getDraftId())
}

// add a smooth scroll effect for non Chrome browsers
polyfill()

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__)
  store.commit('booking/cabin1/transportAir/REIMPORT')
  store.commit('booking/cabin2/transportAir/REIMPORT')
  store.commit('booking/cabin3/transportAir/REIMPORT')
  store.commit('booking/cabin4/transportAir/REIMPORT')
}
sync(store, router)

// init exchange rate for price conversion
store.dispatch(
  'searching/exchangeRates/setLocation',
  root.locationTld !== 'LOCALHOST' ? root.locationTld : 'DE'
)
store.dispatch(
  'campaigns/exchangeRates/setLocation',
  root.locationTld !== 'LOCALHOST' ? root.locationTld : 'DE'
)
if (root.locationTld !== 'DE') {
  store.dispatch('searching/exchangeRates/importExchangeRates')
  store.dispatch('searching/exchangeRates/setConvert', true)

  store.dispatch('campaigns/exchangeRates/importExchangeRates')
  store.dispatch('campaigns/exchangeRates/setConvert', true)
}

// init tracking module
const routingTrackingHandlers = Tracking.onRouting($store)
router.beforeEach(routingTrackingHandlers.beforeEach)

router.afterEach(routingTrackingHandlers.afterEach)
router.onReady(() => {
  // time measurement
  window.timingMeasurement.routerReady = Date.now()
})
Tracking.init(store)

app.then(resolvedApp => {
  // actually mount to DOM
  resolvedApp.$mount('#app')
})
